if (!customElements.get('search-overlay')) {
  customElements.define('search-overlay', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.input = this.querySelector('[name="q"]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-search-open]');
        if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        clearTimeout(this.closeTimer);
        const drawer = trigger.closest('header-drawer');
        this.opener = drawer?.querySelector('[data-drawer-open]') || trigger;
        drawer?.close();
        if (!this.dialog.open) this.dialog.showModal();
        this.dialog.getBoundingClientRect();
        this.dialog.classList.add('is-open');
        this.input.focus({ preventScroll: true });
      }, options);
      this.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        const outside = event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
        if (outside || event.target.closest('[data-search-close]')) this.close();
      }, options);
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
      this.form.addEventListener('submit', (event) => {
        this.input.value = this.input.value.trim();
        if (!this.input.value) { event.preventDefault(); this.input.focus(); return; }
        this.form.setAttribute('aria-busy', 'true');
      }, options);
      window.addEventListener('pageshow', () => { this.form.removeAttribute('aria-busy'); }, options);
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.closeTimer); }
    close() {
      clearTimeout(this.closeTimer);
      this.dialog.classList.remove('is-open');
      const finish = () => { this.dialog.close(); this.opener?.focus({ preventScroll: true }); };
      const duration = Math.max(...getComputedStyle(this.dialog).transitionDuration.split(',').map((value) => parseFloat(value) * 1000));
      if (!duration || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else this.closeTimer = setTimeout(finish, duration);
    }
  });
}
